import { render, staticRenderFns } from "./DeleteLocation.vue?vue&type=template&id=5ad91ea0"
import script from "./DeleteLocation.vue?vue&type=script&lang=js"
export * from "./DeleteLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports